module.exports = __webpack_public_path__ + "img/lens-167-minus-10.33bb35ef.png";